export default "__VITE_ASSET__8385d690__"